import { Box, Container } from "@mui/material";
import React from "react";
import BackBtn from "../../widgets/BackBtn";

const EditBusiness = () => {
  return (
    <Container maxWidth="md" sx={{ mt: 3 }}>
      <BackBtn />
      <Box></Box>
    </Container>
  );
};

export default EditBusiness;
